import { Component, Inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
import { PrimeNG } from 'primeng/config';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { filter, mergeMap } from 'rxjs';
import { NavbarComponent } from '../components/navbar/navbar.component';
import { AuthenticationService } from '../services/authentication.service';
import { NavbarService } from '../services/navbar.service';
// import { OneSignal } from 'onesignal-ngx';
import { AuthStateService } from '../services/authstate.service';


@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToastModule,
    NavbarComponent,
    ConfirmDialogModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Motion';
  currentPath: string[] = []


  constructor(
    // private authService: AuthenticationService,
    private authState: AuthStateService,
    private router: Router,
    private transloco: TranslocoService,
    private translocoLocale: TranslocoLocaleService,
    private primengConfig: PrimeNG,
    public nav: NavbarService,
    // private oneSignal: OneSignal,
    @Inject('ENVIRONMENT') private ENV: any
  ) {
    router.events.subscribe((event) => {
      this.currentPath = this.router.url.split('/');
    });

    this.translocoLocale.setLocale(transloco.getActiveLang() == 'it' ? 'it-IT' : 'en-US');

    this.transloco.events$
      .pipe(
        filter(event => event.type === 'translationLoadSuccess'),
        mergeMap(() => this.transloco.langChanges$),
      )
      .subscribe(lang => {
        this.translocoLocale.setLocale(lang == 'it' ? 'it-IT' : 'en-US');
      });

    // this.oneSignal.init({
    //   ...ENV.oneSignalConfig
    // }).then(() => {
    //   console.log("Onesignal Initialized");
    //   authState.changes$.subscribe(state => {
    //     if (state === "LOGGED") {
    //       oneSignal.User.addTags({
    //         username: authState.loginData.user.username,
    //         email: authState.loginData.user.email,
    //       });
    //       this.oneSignal.login(authState.loginData.user.userId).then(() => {
    //         console.log("Onesignal Logged");
    //       }).catch(err => {
    //         console.error(err);
    //       })
    //     } else if (state === "LOGOUT") {
    //       this.oneSignal.logout().then(() => {
    //         console.log("Onesignal Logged Out");
    //       }).catch(err => {
    //         console.error(err);
    //       })
    //     }
    //   })
    // }).catch(err => {
    //   console.error(err);
    // })
  }

  ngOnInit(): void {
    this.transloco.selectTranslateObject("primeng").subscribe((val) => {
      this.primengConfig.setTranslation(val);
    })
  }
}
